import { render } from "./RegionDashboardsExportButtons.vue?vue&type=template&id=2e458790&ts=true"
import script from "./RegionDashboardsExportButtons.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsExportButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__